import { Typography } from '@mui/material'
import { useRef } from 'react'

function Lazy({ visible, children }) {
	const rendered = useRef(visible)

	if (visible && !rendered.current) {
		rendered.current = true
	}

	if (!rendered.current) return null

	return <div style={{ display: visible ? 'block' : 'none' }}>{children}</div>
}

export const LazyTabPanel = (props) => {
	const { children, value, index, ...other } = props

	return (
		<Typography component="div" role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`}>
			<Lazy visible={value === index}>{children}</Lazy>
		</Typography>
	)
}
